module.exports = __webpack_public_path__ + "img/1270342288.28c18efd.jpg";